import { TActState } from "../services/banner";
export const formatAspect = (side) => {
    if (typeof side === "string" && isNaN(+side)) {
        return 0;
    }
    return +side;
};
export const formatBannerGridSize = (banner, gridWidth) => {
    const bannerWidth = formatAspect(banner.width || "");
    gridWidth = Math.max(gridWidth, bannerWidth);
    const bannerHeight = formatAspect(banner.height || "");
    const aspectRatio = bannerWidth ? (+bannerHeight / bannerWidth).toFixed(3) : 0;
    return {
        width: gridWidth,
        height: +aspectRatio * gridWidth,
        aspectRatio: +aspectRatio,
    };
};
export const isValidState = (state) => {
    return [TActState.ComingSoon, TActState.OnGoing].includes(state);
};
export const isUnValidState = (state) => {
    return [TActState.UnkonwnActState, TActState.Ended].includes(state);
};
